
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PlusCircle } from "lucide-react";

interface BlogPostsHeaderProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const BlogPostsHeader = ({ searchTerm, setSearchTerm }: BlogPostsHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
      <div className="w-full md:w-1/3">
        <Input
          placeholder="Search posts..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full"
        />
      </div>
      <Button 
        className="bg-elfGreen hover:bg-elfGreen-dark w-full md:w-auto"
        onClick={() => navigate("/admin/new-post")}
      >
        <PlusCircle size={16} className="mr-2" /> Create New Post
      </Button>
    </div>
  );
};

export default BlogPostsHeader;
